import {Modal} from "antd";
import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {setMe} from "../../../core/app/setMe/actions";
import {setModalVisibility} from "../../../core/app/setModalVisibility/actions";
import {ModalType} from "../../../core/models/custom/enums/modalType";
import {ModalVisibilityPayload} from "../../../core/models/custom/modalVisibility.payload";
import {MeDto} from "../../../core/models/dtos/me.dto";
import {Popup} from "../../../core/models/enums/popup";
import {seePopup} from "../../../core/services/userService/seePopup/actions";
import {SeePopupState} from "../../../core/services/userService/seePopup/types";
import ContentKeys from "../../../core/utilities/contentKeys";
import {withRouter, WithRouterProps} from "../../../core/utilities/hooks";
import {Images} from "../../../core/utilities/images";
import {IStore} from "../../../core/utilities/reducers";
import {router} from "../../../core/utilities/router";
import {UI} from "../../../core/utilities/ui";
import AppButton from "../../Buttons/AppButton/AppButton";
import ContentKey from "../../ContentKey/ContentKey";
import ModalHeader from "../Common/ModalHeader/ModalHeader";
import "./ScoreboardModal.scss";

interface IProps {
  me?: MeDto;
  contents: Map<string, string>;
  seePopupState: SeePopupState;
  setMe: (me?: MeDto) => void;
  seePopup: (popup: Popup) => void;
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
}

class ScoreboardModal extends React.Component<WithRouterProps<IProps>> {
  private readonly modal = ModalType.SCOREBOARD;
  
  componentDidMount() {
    this.props.seePopup(Popup.SCOREBOARD);
  }
  
  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {
    if (prevProps.seePopupState.loading && !this.props.seePopupState.loading) {
      if (this.props.seePopupState.data) {
        const me = this.props.me;
        if (me) {
          me.shouldSeeScoreboard = false;
          this.props.setMe(me);
        }
      }
    }
  }
  
  private handleModal(isApproved: boolean): void {
    this.props.setModalVisibility({modal: this.modal, isVisible: false});
    if (isApproved) {
      this.props.navigate(router.QUESTION);
    }
  }
  
  render() {
    return (
      <Modal
        className="scoreboard-modal"
        maskStyle={UI.modalMaskStyle()}
        open
        closable={false}
        footer={false}
        centered
        destroyOnClose
        onCancel={() => this.handleModal(false)}
      >
        <ModalHeader
          className="scoreboard-modal"
          text={<ContentKey contentKey={ContentKeys.LIG_POPUP_HEADER}/>}
          icon={<img className="icon" src={Images.popup_header_icon_gift} alt="icon"/>}
        />
        
        <div className="body">
          
          <img
            className="league"
            src={Images.scoreboard_banner}
            alt="league"
          />
          
          <ContentKey
            className="text text-medium"
            contentKey={ContentKeys.LIG_POPUP_DESC}
          />
          
          <AppButton
            text={
              <ContentKey
                contentKey={ContentKeys.LIG_POPUP_BUTTON}
              />
            }
            onClick={() => this.handleModal(true)}
          />
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setMe,
      seePopup,
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    contents: store.getContents.data,
    seePopupState: store.seePopup,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter<IProps>(ScoreboardModal));
